const ModalOpenButton = ({ onClick, children, theme="white" }) => {

  const seletedTheme = {
    white: `border border-gray-200 bg-white
            text-gray-700
            hover:bg-gray-50
            hover:border-gray-300`,
    black: `bg-[#022047] text-white
            hover:brightness-110
            hover:shadow-md`
  }[theme]

  return (
    <button
      onClick={onClick}
      className={`h-10 px-5 rounded-2xl text-sm font-semibold cursor-pointer ${seletedTheme} transition-all duration-200
      `}
    >
      {children}
    </button>
  )
}

export default ModalOpenButton